@if (status) {
  <span class="status-container seat-status-text" fxLayoutAlign="start">
    <span fxLayoutAlign="end center">
      <svg width="15" height="10">
        <circle
          [class]="getSeatStatusColor()"
          class="status-dot"
          cx="5"
          cy="5"
          r="4"
          stroke-width="0"
        />
      </svg>
    </span>
    <span
      fxLayoutAlign="start center"
      [matMenuTriggerFor]="statusOverride"
      id="person-status-override"
      data-testid="card-person-status-override"
      [ngClass]="{
        'menu-button': true,
        'disable-menu': !canEditPersonOnTeam()
      }"
      >{{ getSeatStatusText() }}
      @if (canEditPersonOnTeam()) {
        <mat-icon id="status-override-action">arrow_drop_down</mat-icon>
      }
    </span>
    <mat-menu #statusOverride="matMenu">
      <span class="seat-status">Override the status:</span>
      <button
        class="status-override"
        [disabled]="isPicked()"
        (click)="overridePicked()"
        id="person-picked"
        mat-menu-item
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div class="menu-item-text">
            <svg width="15" height="10">
              <circle
                class="getSeatStatusText()"
                class="status-dot Picked"
                cx="5"
                cy="5"
                r="4"
                stroke-width="0"
              />
            </svg>
            <span>Picked</span>
          </div>
          @if (isPicked()) {
            <mat-icon>check</mat-icon>
          }
        </div>
      </button>
      <button
        class="status-override"
        [disabled]="isInvited()"
        (click)="overrideInvited()"
        id="person-invited"
        mat-menu-item
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div class="menu-item-text">
            <svg width="15" height="10">
              <circle
                class="getSeatStatusText()"
                class="status-dot Invited"
                cx="5"
                cy="5"
                r="4"
                stroke-width="0"
              />
            </svg>
            <span>Invited</span>
          </div>
          @if (isInvited()) {
            <mat-icon>check</mat-icon>
          }
        </div>
      </button>
      <button
        class="status-override"
        [disabled]="isNoResponse()"
        (click)="overrideNoResponse()"
        id="person-noresponse"
        mat-menu-item
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div class="menu-item-text">
            <svg width="15" height="10">
              <circle
                class="getSeatStatusText()"
                class="status-dot NoResponse"
                cx="5"
                cy="5"
                r="4"
                stroke-width="0"
              />
            </svg>
            <span>No Response</span>
          </div>
          @if (isNoResponse()) {
            <mat-icon>check</mat-icon>
          }
        </div>
      </button>
      <button
        class="status-override"
        [disabled]="isAccepted()"
        (click)="overrideAccepted()"
        id="person-accepted"
        mat-menu-item
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div class="menu-item-text">
            <svg width="15" height="10">
              <circle
                class="getSeatStatusText()"
                class="status-dot Accepted"
                cx="5"
                cy="5"
                r="4"
                stroke-width="0"
              />
            </svg>
            <span>Accepted</span>
          </div>
          @if (isAccepted()) {
            <mat-icon>check</mat-icon>
          }
        </div>
      </button>
      <button
        class="status-override"
        [disabled]="isDeclined()"
        (click)="overrideDeclined()"
        id="person-declined"
        mat-menu-item
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div class="menu-item-text">
            <svg width="15" height="10">
              <circle
                class="getSeatStatusText()"
                class="status-dot Declined"
                cx="5"
                cy="5"
                r="4"
                stroke-width="0"
              />
            </svg>
            <span>Declined</span>
          </div>
          @if (isDeclined()) {
            <mat-icon>check</mat-icon>
          }
        </div>
      </button>
      <button
        class="status-override"
        [disabled]="isNoShow()"
        (click)="overrideNoShow()"
        id="person-noshow"
        mat-menu-item
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div class="menu-item-text">
            <svg width="15" height="10">
              <circle
                class="getSeatStatusText()"
                class="status-dot NoShow"
                cx="5"
                cy="5"
                r="4"
                stroke-width="0"
              />
            </svg>
            <span>No Show</span>
          </div>
          @if (isNoShow()) {
            <mat-icon>check</mat-icon>
          }
        </div>
      </button>
    </mat-menu>
  </span>
}
